import { Button, Col, Flex, Form, Row } from 'antd';
import { FormInstance } from 'antd/es/form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';

import FileInput from 'components/fileInput/fileInput';
import FormElement from 'components/formElement/formElement';
import ListButton from 'components/listButton/listButton';
import Icon from 'utils/icon';

interface FormItemInputProps {
	form: FormInstance;
	fieldName: string;
	title?: string;
	editMode?: boolean;
	withTitle?: boolean;
	onDelete?(id: string | number): void;
}

function FormListFilesElement({ form, fieldName, title, editMode, withTitle = true, onDelete }: FormItemInputProps) {
	const { t } = useTranslation();
	return (
		<>
			<h6>{title}</h6>
			<Form.List
				name={fieldName}
				rules={[
					{
						validator: async (_, files) => {
							if (!files || files.length < 1) {
								return Promise.reject(new Error(t('ACTIONS.SELECT_AT_LEAST_ONE_LOCATION')));
							}
						},
					},
				]}>
				{(fields, { add, remove }) => (
					<Row gutter={[16, 10]}>
						{fields.map(({ key, name, ...restField }, index) => (
							<Fragment key={key}>
								{withTitle && (
									<Col span={24} md={12}>
										<FormElement
											{...restField}
											name={[`${name}`, 'title']}
											label={t('ACTIONS.DOCUMENT_TITLE')}
											type="text"
											rules={[{ required: true, message: t('COMMON.FIELD_REQUIRED') }]}
										/>
									</Col>
								)}

								<Col span={24} md={withTitle ? 12 : 24}>
									<Flex align="center" gap={40}>
										<Form.Item
											{...restField}
											name={[name, 'file']}
											style={{ display: 'block', width: 'var(--inputWidth)', maxWidth: '100%', marginBottom: 0 }}
											rules={[{ required: !editMode, message: t('COMMON.FIELD_REQUIRED') }]}>
											<FileInput
												accept="pdf"
												onSelect={(file) => {
													onDelete && onDelete(form.getFieldValue([fieldName, name, 'id']));
													form.setFieldValue([fieldName, name, 'file'], file);
												}}
											/>
										</Form.Item>

										{index > 0 && (
											<ListButton
												type="delete"
												onClick={() => {
													onDelete && onDelete(form.getFieldValue([fieldName, name, 'id']));
													remove(name);
												}}
											/>
										)}
									</Flex>
								</Col>
							</Fragment>
						))}

						<Col span={24}>
							<Button type="link" className="p-0" onClick={() => add()}>
								<Icon name="upload" color="var(--primary)" />
								{t('ACTIONS.UPLOAD_ANOTHER_FILE')}
							</Button>
						</Col>
					</Row>
				)}
			</Form.List>
		</>
	);
}

export default FormListFilesElement;
